export default "__VITE_ASSET__DnYkCxQE__"